export const MAXPROVIDERCOUNT = 5;

export const CONSTPROVIDERLIST = {
  0: {
    "provider-group": [],
    emirate: [],
    "provider-type": [],
    "provider-name": [],
    "clinician-speciality": [],
    "clinician-name": [],
    "transaction-fromdate": ["01-01-2025"],
    "transaction-todate": ["31-12-2025"],
    "claim-status": ["partially_paid", "paid", "open", "rejected"],
    "claim-type": ["1"],
    encounter: ["outpatient"],
  },
  //   1: {
  //     "provider-group": [],
  //     "provider-type": [],
  //     "provider-name": [],
  //     "clinician-speciality": [],
  //     "clinician-name": [],
  //     "transaction-fromdate": ["01-01-2021"],
  //     "transaction-todate": ["31-12-2021"],
  //     "claim-status": ["partially_paid", "paid", "open", "rejected"],
  //     "claim-type": ["1"],
  //     encounter: ["outpatient"],
  //   },
  // 2: {
  //   "provider-group": [],
  //   "provider-type": [],
  //   "provider-name": [],
  //   "clinician-speciality": [],
  //   "clinician-name": [],
  //   "transaction-fromdate": ["01-01-2022"],
  //   "transaction-todate": ["31-12-2022"],
  //   "claim-status": ["partially_paid", "paid", "open", "rejected"],
  //   "claim-type": ["1"],
  //   encounter: ["outpatient"],
  // },
};
